import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
var _excluded = ["hideLabel", "icon", "isActive", "outline", "text"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { TextStyled, ToggleStyled } from "./styles";
import { Box } from "../Box";
import { BLUE } from "../../constants/colors/hex";
export var ToggleButton = function ToggleButton(_ref) {
  var hideLabel = _ref.hideLabel,
    Icon = _ref.icon,
    isActive = _ref.isActive,
    _ref$outline = _ref.outline,
    outline = _ref$outline === void 0 ? true : _ref$outline,
    text = _ref.text,
    props = _objectWithoutProperties(_ref, _excluded);
  var showText = !hideLabel && !!text;
  return /*#__PURE__*/React.createElement(ToggleStyled, _extends({}, props, {
    "aria-label": hideLabel ? text : undefined,
    "aria-pressed": isActive,
    isActive: isActive,
    outline: outline
  }), Icon && /*#__PURE__*/React.createElement(Box, {
    lineHeight: 1,
    mr: showText ? 1.5 : 0
  }, /*#__PURE__*/React.createElement(Icon, {
    "aria-hidden": true,
    color: isActive ? BLUE[5] : 'gray',
    variant: isActive ? 'fill' : 'outline'
  })), showText && /*#__PURE__*/React.createElement(TextStyled, null, text));
};